/**
 * Sekcje otwartej oferty — jedno źródło prawdy dla nawigacji i routingu.
 *
 * Podział wynika z tego, że oferta ma dwie różne natury:
 *   grupa "wiedza"  — WIEDZA o nieruchomości (skąd wiemy, że lokal jest taki):
 *                     przegląd, księga wieczysta, wycena RCN, zdjęcia i rzuty
 *   grupa "publikacja" — ARTEFAKTY na zewnątrz (co z tej wiedzy produkujemy):
 *                     karta lokalu PDF, strona WWW, kampania social, kampania wideo
 *
 * Sekcja żyje w query paramie `?sekcja=`, nie w ścieżce — dzięki temu
 * /oferty/:projectId zostaje jednym routem i stare linki nadal działają
 * (brak parametru = przegląd).
 */

export type OfferSectionId =
  | "przeglad"
  | "kw"
  | "wycena"
  | "zdjecia"
  | "karta"
  | "www"
  | "kampanie"
  | "kampanie-video";

export type OfferSectionGroup = "wiedza" | "publikacja";

export interface OfferSection {
  id: OfferSectionId;
  label: string;
  icon: string;
  group: OfferSectionGroup;
  /** Etykieta „wkrótce" w nawigacji — sekcja jest widoczna, ale nie ma pełnej funkcji. */
  soon?: boolean;
}

export const OFFER_SECTIONS: OfferSection[] = [
  { id: "przeglad", label: "Przegląd", icon: "layers", group: "wiedza" },
  { id: "kw", label: "Księga wieczysta", icon: "shield", group: "wiedza" },
  { id: "wycena", label: "Wycena wg RCN", icon: "growth", group: "wiedza" },
  { id: "zdjecia", label: "Zdjęcia i rzuty", icon: "image", group: "wiedza" },
  { id: "karta", label: "Karta lokalu PDF", icon: "file", group: "publikacja" },
  { id: "www", label: "Strona WWW", icon: "globe", group: "publikacja" },
  { id: "kampanie", label: "Kampania social", icon: "megaphone", group: "publikacja", soon: true },
  { id: "kampanie-video", label: "Kampania wideo", icon: "camera", group: "publikacja", soon: true },
];

export const GROUP_LABEL: Record<OfferSectionGroup, string> = {
  wiedza: "Wiedza o nieruchomości",
  publikacja: "Publikacja",
};

const IDS = new Set(OFFER_SECTIONS.map((s) => s.id));

/** Parsuje `?sekcja=` na bezpieczny identyfikator (nieznana wartość → przegląd). */
export function parseSection(raw: string | null): OfferSectionId {
  return raw && IDS.has(raw as OfferSectionId) ? (raw as OfferSectionId) : "przeglad";
}
